export const HOME_SLICE = "home";
